<template>
  <div
    id="modalMissingPlatformSubscription"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="modalMissingPlatformSubscriptionLabel"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border-0 shadow-lg">
        <div class="modal-header border-0 pb-0">
          <div class="d-flex align-items-center gap-3">
            <div
              class="symbol symbol-50px symbol-circle bg-light-warning flex-shrink-0 d-flex align-items-center justify-content-center"
            >
              <i class="bi bi-exclamation-triangle text-warning fs-2"></i>
            </div>
            <div>
              <h5 id="modalMissingPlatformSubscriptionLabel" class="modal-title mb-0 text-gray-900">
                Assinatura não configurada
              </h5>
              <p v-if="placeName" class="text-muted fs-7 mb-0">
                {{ placeName }}<span v-if="placeId"> · #{{ placeId }}</span>
              </p>
            </div>
          </div>
        </div>

        <div class="modal-body pt-5 pb-6 px-8">
          <p class="text-gray-800 mb-3">
            Este local ainda não possui assinatura da plataforma vinculada. Por isso algumas
            funcionalidades podem falhar ao carregar dados.
          </p>
          <p class="text-muted fs-7 mb-0">
            Solicite à equipe Ubbimed a configuração. Você pode continuar
            navegando para identificar o problema, mas o uso normal do sistema depende da assinatura.
          </p>
        </div>

        <div class="modal-footer border-0 pt-0 px-8 pb-8">
          <router-link to="/places" class="btn btn-light" @click="close">
            Trocar local
          </router-link>
          <button type="button" class="btn btn-primary" @click="close">
            Entendi
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalMissingPlatformSubscription',
  props: {
    placeName: {
      type: String,
      default: '',
    },
    placeId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      modalInstance: null,
    };
  },
  mounted() {
    const el = document.getElementById('modalMissingPlatformSubscription');
    this.modalInstance = bootstrap.Modal.getOrCreateInstance(el, {
      backdrop: 'static',
      keyboard: false,
    });
  },
  beforeUnmount() {
    this.modalInstance?.hide();
  },
  methods: {
    open() {
      this.modalInstance?.show();
    },
    close() {
      this.modalInstance?.hide();
    },
  },
};
</script>
